var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetPasswordSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5007 46.0418C36.24 46.0418 39.6255 44.5261 42.076 42.0755C44.5266 39.625 46.0423 36.2396 46.0423 32.5002C46.0423 28.7608 44.5266 25.3753 42.076 22.9248C39.6255 20.4742 36.24 18.9585 32.5007 18.9585C28.7613 18.9585 25.3758 20.4742 22.9252 22.9248C20.4747 25.3753 18.959 28.7608 18.959 32.5002C18.959 36.2396 20.4747 39.625 22.9252 42.0755C25.3758 44.5261 28.7613 46.0418 32.5007 46.0418Z",
    fill: "#59C180",
    stroke: "#121121",
    strokeWidth: 2.32143,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.084 32.5L31.1465 36.5625L39.2715 28.4375",
    stroke: "#121121",
    strokeWidth: 2.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPasswordSuccess);
export default __webpack_public_path__ + "static/media/reset-password-success.67e430fba920c8b0496b6e185e1769b5.svg";
export { ForwardRef as ReactComponent };